// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../data/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Bulma Utilities */\n.form-option-set .b-radio.radio {\n  align-items: start;\n}\n.form-option-set .message {\n  font-size: 0.9rem;\n  margin-bottom: 0.5rem;\n}\n.form-option-set li:not(:last-child) {\n  margin-bottom: 0.5em;\n}\n.form-option-set.inline .b-radio.radio:not(:last-child) {\n  margin-right: 1rem;\n}\n", ""]);
// Exports
module.exports = exports;
